import React from 'react';
import { ArrowTurnDownIcon, Box, Inscription } from '@common-fe/common-fe';

import ConfirmUpdatesPropertyRow from './ConfirmUpdatesPropertyRow';
import { PropertyChangeItem } from './SyncUpdatesModal.types';

interface Group {
  groupType: string;
  section: string;
  items: PropertyChangeItem[];
}

interface Props {
  group: Group;
  selected: string[];
  isAppliedToLowerOrgs: (property: PropertyChangeItem) => boolean;
  showSeparator: boolean;
}

const ConfirmUpdatesGroupCard: React.FC<Props> = ({ group, selected, isAppliedToLowerOrgs, showSeparator }) => {
  return (
    <>
      {showSeparator && <Box background="border1" margin={{ vertical: 'xs' }} height="1px" />}
      <Box direction="column" gap="spacing4" pad="2px" data-testid={`confirm-updates-modal_group-card_${group.section}`}>
        <Box
          direction="row"
          align="center"
          gap="spacing6"
          data-testid={`confirm-updates-modal_group_${group.section}`}
        >
          <Inscription color="textSecondary" size="small" lineHeight="18px">
            {group.section}
          </Inscription>
          <ArrowTurnDownIcon color="iconSecondary" size="12px" />
        </Box>
        {group.items.map((item) => (
          <ConfirmUpdatesPropertyRow
            key={item.propertyName}
            item={item}
            isSelected={selected.includes(item.propertyName)}
            isAppliedToLowerOrgs={isAppliedToLowerOrgs(item)}
            isBold={!item.hasDependencyWarning}
          />
        ))}
      </Box>
    </>
  );
};

export default ConfirmUpdatesGroupCard;
